import React, {lazy, Suspense} from 'react';

const AiHandoffActionsShimmerComponent = lazy(
  () => import('./aiHandoffActionsShimmerComponent'),
);
const ChatContainerShimmerComponent = lazy(
  () => import('./chatContainerShimmerComponent'),
);
const ChatListBoxShimmerComponent = lazy(
  () => import('./chatListBoxShimmerComponent'),
);
const ChatRoomTaskOwnerShimmerComponent = lazy(
  () => import('./chatRoomTaskOwnerShimmerComponent'),
);
const DatePickerShimmerComponent = lazy(
  () => import('./datePickerShimmerComponent'),
);
const FloikShimmerComponent = lazy(() => import('./floikShimmerComponent'));
const LeadsFormShimmerComponent = lazy(
  () => import('./leadsFormShimmerComponent'),
);
const LeadsShimmerComponent = lazy(() => import('./leadsShimmerComponent'));
const MediaTabShimmerComponent = lazy(
  () => import('./mediaTabShimmerComponent'),
);
const OverviewAgendaShimmerComponent = lazy(
  () => import('./overviewAgendaShimmerComponent'),
);
const OverviewUnReadMessagesShimmerComponent = lazy(
  () => import('./overviewUnReadMessagesShimmerComponent'),
);
const OverviewVoiceMessagesShimmerComponent = lazy(
  () => import('./overviewVoiceMessagesShimmerComponent'),
);
const PartnershipsShimmerComponent = lazy(
  () => import('./partnershipsShimmerComponent'),
);
const ProfileAreaShimmerComponent = lazy(
  () => import('./profileAreaShimmerComponent'),
);
const ClientChatContainerShimmerComponent = lazy(
  () => import('./clientChatContainerShimmerComponent'),
);
const SessionInstanceChatShimmerComponent = lazy(
  () => import('./sessionInstanceChatShimmerComponent'),
);

import VIDABOO_CONSTANTS from '../../../../../config/consts';

const ShimmerWithEmptyImageComponent = ({
  showShimmer = true,
  shimmerComponentType = null,
}) => {
  return (
    <>
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.OVERVIEW_AGENDA && (
        <Suspense fallback={null}>
          <OverviewAgendaShimmerComponent showShimmer={showShimmer} />
        </Suspense>
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.OVERVIEW_VOICE_MESSAGES && (
        <Suspense fallback={null}>
          <OverviewVoiceMessagesShimmerComponent showShimmer={showShimmer} />
        </Suspense>
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.OVERVIEW_UNREAD_MESSAGES && (
        <Suspense fallback={null}>
          <OverviewUnReadMessagesShimmerComponent showShimmer={showShimmer} />
        </Suspense>
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.CHAT_CENTER_CHAT_LIST && (
        <Suspense fallback={null}>
          <ChatListBoxShimmerComponent showShimmer={showShimmer} />
        </Suspense>
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES
          .CHAT_CENTER_CHAT_CONTAINER && (
        <Suspense fallback={null}>
          <ChatContainerShimmerComponent showShimmer={showShimmer} />
        </Suspense>
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.CLIENT_CHAT_CONTAINER && (
        <Suspense fallback={null}>
          <ClientChatContainerShimmerComponent />
        </Suspense>
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES
          .CHAT_CENTER_PROFILE_CONTAINER && (
        <Suspense fallback={null}>
          <ProfileAreaShimmerComponent />
        </Suspense>
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.LEADS && (
        <Suspense fallback={null}>
          <LeadsShimmerComponent showShimmer={showShimmer} />
        </Suspense>
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.LEADS_FORM && (
        <Suspense fallback={null}>
          <LeadsFormShimmerComponent />
        </Suspense>
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.DATE_PICKER && (
        <Suspense fallback={null}>
          <DatePickerShimmerComponent />
        </Suspense>
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.AI_HANDOFF_ACTIONS && (
        <Suspense fallback={null}>
          <AiHandoffActionsShimmerComponent />
        </Suspense>
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.CHAT_ROOM_TASK_OWNER && (
        <Suspense fallback={null}>
          <ChatRoomTaskOwnerShimmerComponent />
        </Suspense>
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.SESSION_INSTANCE_CHAT && (
        <Suspense fallback={null}>
          <SessionInstanceChatShimmerComponent />
        </Suspense>
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.FLOIK && (
        <Suspense fallback={null}>
          <FloikShimmerComponent />
        </Suspense>
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.MEDIA_TAB && (
        <Suspense fallback={null}>
          <MediaTabShimmerComponent />
        </Suspense>
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.PARTNERSHIPS && (
        <PartnershipsShimmerComponent />
      )}
    </>
  );
};

export default ShimmerWithEmptyImageComponent;
